import styles from "./css/TabBarItem.module.css";

interface TabBarItemProps {
  id: number;
  title: string;
  selected: boolean;
  handleClick: (id: number) => void;
}

export default function TabBarItem(props: TabBarItemProps) {
  const tintColor = {
    color: props.selected
      ? "var(--text-accent-color)"
      : "var(--text-tertiary-color)",
  };

  const opacity = {
    opacity: props.selected ? 1 : 0,
  };

  function handleOnClick() {
    props.handleClick(props.id);
  }

  return (
    <>
      <div className={styles.container} onClick={() => handleOnClick()}>
        <span className={styles.titleText} style={tintColor}>
          {props.title}
        </span>
        <div className={styles.underLine} style={opacity}></div>
      </div>
    </>
  );
}
